export const search: object = {
  search: {
    search: 'Search',
    sortBy: 'Sort by:',
    mobileSortBy: 'Sort by',
    clearAll: 'Clear All',
    enterKeyword: 'Enter {{field}}',
    placeholder: 'Search by Solution, Publisher, Keyword',
    searchSuggestions: 'Search Suggestions',
    recentlySearched: 'Recently Searched',
    solutionSuggestions: 'Solution Suggestions',
    facetSearchPlaceholder: 'Search',
    moreFilters: 'More Filters',
    filterAndSort: 'Filter and Sort',
    allFilters: 'All Filters',
    showResults: 'Show {{count}} Results',
    reset: 'Reset',
    noSearchResults: {
      header: 'Sorry, no search results were found',
      description: 'Make sure that all words were spelled correctly, or search for a new keyword.'
    }
  },
};
